<template>
  <div class="container coupon">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item>乐高原创</el-breadcrumb-item>
        <el-breadcrumb-item>页面列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">页面列表</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handlePageCreate"
          >添加页面</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="页面名称"
          prop="name"
        >
          <el-input
            v-model="query.name"
            placeholder="输入页面名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="status"
        >
          <el-select
            v-model="query.status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          :data="results"
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="页面"
            min-width="160"
          >
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述"
            min-width="280"
          >
          </el-table-column>
          <el-table-column
            prop="creage_time"
            label="创建时间"
            width="160"
          >
            <template slot-scope="scope">
              <span>{{  $moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')  }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="updagte_time"
            label="最后编辑时间"
            width="160"
          >
            <template slot-scope="scope">
              <span>{{  $moment(scope.row.update_time).format('YYYY-MM-DD HH:mm')  }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="creator"
            label="创建人"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleToEdit(scope.row)"
              >编辑</el-button>
              <el-button
                type="text"
                size="small"
                @click="handleToDetail(scope.row)"
              >查看</el-button>
              <el-button
                type="text"
                size="small"
                @click="handleToPreview(scope.row)"
              >预览</el-button>
              <el-button
                type="text"
                size="small"
                @click="handleToDelete(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <PageCreate
      :visible="createDialog"
      @close="createDialog = false"
      @submit="fetchPageList"
    ></PageCreate>
    <PageEdit
      :visible="editDialog"
      :content="editRow"
      @close="editDialog = false"
      @submit="fetchPageList"
    ></PageEdit>
  </div>
</template>

<script>
import PageCreate from '@/components/dialog/page/PageCreate'
import PageEdit from '@/components/dialog/page/PageEdit'
import { pageList, pageOne, pageCreate, pageUpdate, pageDestroy } from '@/api/page'

export default {
  components: {
    PageCreate,
    PageEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {},
      query: {
        name: '',
        status: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '正常', value: '1' },
          { label: '关闭', value: '0' }
        ],
      },
      results: []
    }
  },
  created() {
    this.parseQuery()
    this.fetchPageList()
    this.$store.dispatch('getUserCategorys')
    this.$store.dispatch('getAdminList')
  },
  methods: {
    // 优惠券列表请求
    fetchPageList() {
      pageList(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchPageList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchPageList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchPageList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchPageList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        '1': '正常',
        '2': '关闭'
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 页面创建
    handlePageCreate() {
      this.createDialog = true
    },
    handleToPreview(row) {
      const viewHost = location.host.includes('admin.kaoyanbox.com') ? 'http://activity.kaoyanbox.net' : 'http://test-activity.kaoyanbox.net'
      window.open(`${viewHost}/page/${row.id}`, '_blank')
    },
    handleToEdit(row) {
      this.editRow = Object.assign({}, row, { status: row.status == 1 ? true : false })
      this.editDialog = true
    },
    handleToDetail(row) {
      this.$router.push(`/page/detail/${row.id}`)
    },
    handleToDelete(row) {
      // 二次确认撤销
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      }).then(() => {
        pageDestroy({ id: row.id }).then(res => {
          this.$message.success("删除成功")
          this.fetchPageList()
        })
      }).catch(() => { });
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },
  }
}
</script>

<style scoped lang="less">
.coupon {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
